export const mapStyleMappings = {
    vector: {
        'basic-main': 'basic_main',
        'basic-night': 'basic_night',
        'hybrid-main': 'hybrid_main',
        'hybrid-night': 'hybrid_night',
        'labels-main': 'labels_main',
        'labels-night': 'labels_night',
        'basic-light': 'basic_light-map',
        'hybrid-light': 'hybrid_light-map',
        'labels-light': 'labels_light-map'
    },
    raster: {
        'basic-main': 'basic_main',
        'basic-night': 'basic_night',
        'hybrid-main': 'hybrid_main',
        'hybrid-night': 'hybrid_night',
        'labels-main': 'labels_main',
        'labels-night': 'labels_night'
    }
};

export const trafficFlowStyleMappings = {
    vector: {
        'absolute': 'absolute',
        'relative': 'relative',
        'relative-delay': 'relative-delay',
        'relative0': 'relative0',
        'relative0-dark': 'relative0-dark',
        'reduced-sensitivity': 'reduced-sensitivity'
    },
    raster: {
        'absolute': 'absolute',
        'relative': 'relative',
        'relative-delay': 'relative-delay',
        'relative0': 'relative0',
        'relative0-dark': 'relative0-dark',
        'reduced-sensitivity': 'reduced-sensitivity'
    }
};

export const trafficIncidentsStyleMappings = {
    vector: {
        's0': 's0',
        's0-dark': 's0-dark',
        's1': 's1',
        's2': 's2',
        's3': 's3',
        'night': 'night'
    },
    raster: {
        's0': 's0',
        's0-dark': 's0-dark',
        's1': 's1',
        's2': 's2',
        's3': 's3',
        'night': 'night'
    }
};



// WEBPACK FOOTER //
// ./map/configurer/styleOptionInitialization/styleMappings.js